export default "__VITE_ASSET__5044cf17__"